import { APIURLAUTH } from "../constans";
import apiClient from '../libs/axios';

// Ver docs de backend: roles-permisos-contrato-api.md. Son las APIs del CRM
// anterior; varias responden 200 con success: false, asi que se revisa aqui.
const unwrap = (response) => {
    const body = response.data || {};
    if (body.success === false) {
        const error = new Error(typeof body.errorMessage === 'string' ? body.errorMessage : 'Error del servidor');
        error.response = response;
        throw error;
    }
    return body.data;
};

const roles = {
    namespaced: true,
    state: {
        // Catalogo de la matriz: [{ id, title, actions: [{ id, title }] }]
        catalogo: [],
        // Todas las acciones: [{ id, action, title }]
        acciones: [],
        loading: false,
    },

    mutations: {
        setCatalogo(state, catalogo) {
            state.catalogo = catalogo;
        },

        setAcciones(state, acciones) {
            state.acciones = acciones;
        },

        setLoading(state, loading) {
            state.loading = loading;
        },
    },

    actions: {
        // Pagina fija de 5, sin busqueda ni orden en el servidor
        async listarRolesAction(_, page = 1) {
            const response = await apiClient.get(`${APIURLAUTH}/roles-users`, { params: { page } });
            return unwrap(response)?.roles || {};
        },

        // Sin permisos: solo para avisar nombres repetidos
        async listarRolesLigeroAction() {
            const response = await apiClient.get(`${APIURLAUTH}/roles-us`);
            return unwrap(response)?.roles || [];
        },

        // payload: { id?, nombre, descripcion, is_main? } — nunca `type`
        async guardarRolAction({ commit }, payload) {
            commit('setLoading', true);
            try {
                const response = await apiClient.post(`${APIURLAUTH}/roles`, payload);
                return unwrap(response)?.roles || {};
            } finally {
                commit('setLoading', false);
            }
        },

        // Deduplica acciones por id y omite los modulos sin acciones
        async getCatalogoAction({ commit }) {
            const response = await apiClient.get(`${APIURLAUTH}/permissions-actions`);
            const catalogo = (unwrap(response)?.permissions || [])
                .map((modulo) => {
                    const vistas = new Set();
                    const actions = (modulo.actions || []).filter((a) => {
                        if (vistas.has(a.id)) return false;
                        vistas.add(a.id);
                        return true;
                    });
                    return { ...modulo, actions };
                })
                .filter((modulo) => modulo.actions.length);
            commit('setCatalogo', catalogo);
            return catalogo;
        },

        async getAccionesAction({ commit }) {
            const response = await apiClient.get(`${APIURLAUTH}/actions`);
            const acciones = unwrap(response)?.actions || [];
            commit('setAcciones', acciones);
            return acciones;
        },

        // permission: [{ id, actions: [{ id }] }]. Los modulos que no se envian
        // no se tocan; por eso se manda siempre el catalogo completo.
        async guardarMatrizAction({ commit }, { role, permission }) {
            commit('setLoading', true);
            try {
                const response = await apiClient.post(`${APIURLAUTH}/permission/permissions-active-role`, { role, permission });
                return unwrap(response)?.role || {};
            } finally {
                commit('setLoading', false);
            }
        },

        // --- Catalogo (solo superadministrador; el backend no lo comprueba) ---

        async listarModulosAction() {
            const response = await apiClient.get(`${APIURLAUTH}/permission`);
            return unwrap(response)?.permissions || [];
        },

        // payload: { id?, subject, title }
        async guardarModuloAction({ commit }, payload) {
            commit('setLoading', true);
            try {
                const response = await apiClient.post(`${APIURLAUTH}/permissions-module`, payload);
                return unwrap(response) || {};
            } finally {
                commit('setLoading', false);
            }
        },

        // payload: { id?, action, title }
        async guardarAccionAction({ commit }, payload) {
            commit('setLoading', true);
            try {
                const response = await apiClient.post(`${APIURLAUTH}/actions-modules`, payload);
                return unwrap(response) || {};
            } finally {
                commit('setLoading', false);
            }
        },

        // Reemplaza la lista completa. Con `actions` vacio el backend borra
        // todo y luego responde error: no llamar asi.
        async guardarAccionesModuloAction({ commit }, { permission, actions }) {
            commit('setLoading', true);
            try {
                const response = await apiClient.post(`${APIURLAUTH}/actions`, { permission, actions });
                return unwrap(response) || {};
            } finally {
                commit('setLoading', false);
            }
        },
    },
};

export default roles;
